import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import SlideDown from 'components/Common/SlideDown'
import useToggle from 'hooks/useToggle'
import { rem } from 'polished'
import React, { useMemo } from 'react'
import TextLink from 'components/Luxkit/TextLink'
import styled from 'styled-components'
import Spacing from 'components/Common/Spacing'
import { fireInteractionEvent } from 'api/googleTagManager'

interface Props {
  description: string;
  className?: string;
}

const StyledSlideDown = styled(SlideDown)`
  margin-top: 0;

  > * {
    margin-top: ${rem(16)};
  }
`

export default function OfferDescription({ description, className }: Props) {
  const [expanded, toggleReadMore] = useToggle()
  const splitDescription = useMemo(() => description?.length > 0 ? description.split('\n') : [], [description])
  const [shortDescription, ...restOfDescription] = splitDescription
  const expandedDescription = useMemo(() => restOfDescription.length > 1 ? restOfDescription.join('\n') : '', [restOfDescription])

  function toggle() {
    toggleReadMore()
    fireInteractionEvent({
      category: 'offer-page',
      label: 'description-read-more',
      action: 'toggle',
    })
  }

  return (
    <div className={className}>
      {shortDescription && <>
        <MarkdownRender type="compact" content={shortDescription} />
        {expandedDescription && <>
          <StyledSlideDown show={expanded}>
            <MarkdownRender type="compact" content={expandedDescription} />
          </StyledSlideDown>
          <Spacing mt={16}>
            <TextLink endIcon={<DropdownChevron direction={expanded ? 'up' : 'down'}/>} size="medium" onClick={toggle}>
              Read {expanded ? 'less' : 'more'}
            </TextLink>
          </Spacing>
        </>}
      </>}
    </div>
  )
}
